import { useState, useEffect } from "react";
import { appScreens, Breakpoint } from "utils";

export function useBreakpoint() {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const up = (bp: Breakpoint) => width >= Number(appScreens[bp].replace("px", ""));
  const down = (bp: Breakpoint) => width < Number(appScreens[bp].replace("px", ""));

  return {
    width,
    isMobile: width < Number(appScreens.sm.replace("px", "")),
    isTablet: width >= Number(appScreens.sm.replace("px", "")) && width < Number(appScreens.lg.replace("px", "")),
    isDesktop: width >= Number(appScreens.lg.replace("px", "")),
    up, down
    
  };
}
